/**
 * Reorders items so the first item is in the center, the 2nd goes left,
 * 3rd goes right, 4th goes further left, 5th further right, etc.
 *
 * Input order:  [1, 2, 3, 4, 5, 6, 7]
 * Output order: [6, 4, 2, 1, 3, 5, 7]
 */
export function spiralFromCenter<T>(items: T[]): T[] {
	const result: T[] = new Array(items.length);
	const center = Math.floor(items.length / 2);

	for (let i = 0; i < items.length; i++) {
		if (i === 0) {
			result[center] = items[i];
		} else if (i % 2 === 1) {
			// Odd index → place to the right of center
			result[center + Math.ceil(i / 2)] = items[i];
		} else {
			// Even index → place to the left of center
			result[center - i / 2] = items[i];
		}
	}

	return result;
}
